// extracted by mini-css-extract-plugin
module.exports = {"faqHeaderContainer":"faq-header_faqHeaderContainer__hpqp_"};